import { PlanUnit } from '@/generated';
import { CardActionsProps, Grow, Card, CardContent, Typography, Stack, Tooltip, Link } from '@mui/material';
import moment from 'moment';
import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

export const WorkoutUnitCard = (props: { planId?: string; workoutUnit: PlanUnit; children?: ReactElement<CardActionsProps>; timeout: number }) => {
  const navigate = useNavigate();
  const { workoutUnit, children, planId } = props;

  return (
    <Grow in={true} timeout={props.timeout}>
      <Tooltip title={`Key: ${workoutUnit.sortKey}`}>
        <Card sx={{ display: 'flex', flexDirection: 'column', height: '100%' }} className="h-100">
          <CardContent sx={{ flex: 0.9 }} onClick={() => navigate(`/plan-viewer/${planId}/${workoutUnit.idClient}`)}>
            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
              {workoutUnit?.name}
            </Typography>
            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
              {moment(workoutUnit?.trainingDateIso).format('DD.MM.YY - HH:mm')}
            </Typography>
            <Stack direction="row">
              <Typography sx={{ fontSize: 14, justifyContent: 'center', alignContent: 'center' }} color="text.secondary" gutterBottom>
                {workoutUnit.workouts.length} Workouts
              </Typography>
            </Stack>
            <Link onClick={(e) => e.stopPropagation()} sx={{ cursor: 'pointer' }} href={workoutUnit.link?.uri}>
              {workoutUnit.link?.title}
            </Link>
            <Typography sx={{ fontSize: 14, justifyContent: 'center', alignContent: 'center' }} color="text.secondary" gutterBottom>
              {workoutUnit.description}
            </Typography>
          </CardContent>
          {children}
        </Card>
      </Tooltip>
    </Grow>
  );
};
